// document.addEventListener('DOMContentLoaded', function () {
//   debugger;
//   function setupVariantSelection() {
//     // const variantSection = document.querySelector('#variant-radios-template--18352412754020__main');
//     const variantSection = document.querySelector('#variant-selects-template--17183892340822__main');
//     if (!variantSection) return;

//     // const variantRadios = variantSection.querySelectorAll('input[type="radio"][name^="1 bottle"]');
//     // const quantityInput = document.querySelector('#Quantity-template--18352412754020__main');
//     const variantRadios = variantSection.querySelectorAll('input[type="radio"][name^="Bundle & Save"]');
//     const quantityInput = document.querySelector('#Quantity-template--17183892340822__main');

//     if (!quantityInput) return;

//     const variantQuantities = {
//       '1 Bottle': 1,
//       '3 Bottles': 3,
//       '5 Bottles': 5
//     };

//     function updateQuantity() {
//       const selectedVariant = Array.from(variantRadios).find(radio => radio.checked);
//       if (selectedVariant) {
//         quantityInput.value = variantQuantities[selectedVariant.value] || 1;
//         quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
//         updateSubscriptionPrices(selectedVariant.value);
//       }
//     }

//     variantRadios.forEach(radio => {
//       radio.removeEventListener('change', updateQuantity);
//       radio.addEventListener('change', updateQuantity);
//     });

//     updateQuantity();
//   }

//   function updateSubscriptionPrices(selectedVariant) {
//     const oneTimeOption = document.querySelector('.Avada-Subscription__Radio-Item:nth-child(1)');
//     const subscriptionOption = document.querySelector('.Avada-Subscription__Radio-Item:nth-child(2)');

//     const oneTimePrice = oneTimeOption?.querySelector('.Avada-Subscription__Price');
//     const subscriptionPrice = subscriptionOption?.querySelector('.Avada-Subscription__Price');

//     if (!oneTimePrice || !subscriptionPrice) return;

//     // Define correct prices for each variant
//     const variantPrices = {
//         "1 Bottle": { oneTime: "$99.00", sub: "$74.25" },
//         "3 Bottles": { oneTime: "$299.99", sub: "$224.99" },
//         "5 Bottles": { oneTime: "$499.99", sub: "$337.49" }
//     };

//     if (variantPrices[selectedVariant]) {
//         oneTimePrice.textContent = variantPrices[selectedVariant].oneTime;
//         subscriptionPrice.textContent = variantPrices[selectedVariant].sub;
//     }

//     // Ensure the correct active class is applied
//     const subscriptionRadio = subscriptionOption?.querySelector('input[type="radio"]');
//     const oneTimeRadio = oneTimeOption?.querySelector('input[type="radio"]');

//     if (subscriptionRadio?.checked) {
//         oneTimeOption.classList.remove('Avada-Subscription__Radio-Item--Active');
//         subscriptionOption.classList.add('Avada-Subscription__Radio-Item--Active');
//     } else if (oneTimeRadio?.checked) {
//         subscriptionOption.classList.remove('Avada-Subscription__Radio-Item--Active');
//         oneTimeOption.classList.add('Avada-Subscription__Radio-Item--Active');
//     }
//   }

//   // Attach event listeners to subscription selection
//   document.querySelectorAll('.Avada-Subscription__Radio input[type="radio"]').forEach(radio => {
//     radio.addEventListener('change', () => {
//       updateSubscriptionPrices(document.querySelector('input[name="variant"]:checked')?.value);
//     });
//   });

//   setupVariantSelection();

//   // Observe changes in the variant selection area
//   const observer = new MutationObserver(setupVariantSelection);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });


// document.addEventListener('DOMContentLoaded', function () {
//   function setupVariantSelection() {
//     debugger;
//     const variantSection = document.querySelector('#variant-selects-template--17183892340822__main');

//     if (!variantSection) return;

//     const variantRadios = variantSection.querySelectorAll('input[type="radio"][name^="Bundle & Save"]');
//     const quantityInput = document.querySelector('#Quantity-template--17183892340822__main');

//     if (!quantityInput) return;

//     const variantQuantities = {
//       '1 Bottle': 1,
//       '3 Bottles': 3,
//       '5 Bottles': 5
//     };

//     function updateQuantity() {
//       const selectedVariant = Array.from(variantRadios).find(radio => radio.checked);
//       if (selectedVariant) {
//         quantityInput.value = variantQuantities[selectedVariant.value] || 1;

//         // Ensure Shopify scripts detect the change
//         quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
//         quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     }

//     // Remove any previous event listeners and add fresh ones
//     variantRadios.forEach(radio => {
//       radio.removeEventListener('change', updateQuantity);
//       radio.addEventListener('change', updateQuantity);
//     });

//     // Trigger an initial quantity update
//     updateQuantity();
//   }

//   setupVariantSelection();

//   // Observe DOM changes in case the variant section loads dynamically
//   const observer = new MutationObserver(setupVariantSelection);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });


// ////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function () {
  // debugger;
  function setupVariantSelection() {
    // const variantSection = document.querySelector('#variant-radios-template--18352412754020__main');
    const variantSection = document.querySelector('#variant-selects-template--17183892340822__main');
    if (!variantSection) return;

    // const variantRadios = variantSection.querySelectorAll('input[type="radio"][name^="1 bottle"]');
    // const quantityInput = document.querySelector('#Quantity-template--18352412754020__main');
    const variantRadios = variantSection.querySelectorAll('input[type="radio"][name^="Bundle & Save"]');
    const quantityInput = document.querySelector('#Quantity-template--17183892340822__main');

    if (!quantityInput) return;

    const variantQuantities = {
      '1 Bottle': 1,
      '3 Bottles': 3,
      '5 Bottles': 5
    };

    function updateQuantity() {
      const selectedVariant = Array.from(variantRadios).find(radio => radio.checked);
      if (selectedVariant) {
        quantityInput.value = variantQuantities[selectedVariant.value] || 1;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        updateSubscriptionPrices(selectedVariant.value);
      }
    }

    variantRadios.forEach(radio => {
      radio.removeEventListener('change', updateQuantity);
      radio.addEventListener('change', updateQuantity);
    });

    updateQuantity();
  }

  function updateSubscriptionPrices(selectedVariant) {
    const oneTimeOption = document.querySelector('.Avada-Subscription__Radio-Item:nth-child(1)');
    const subscriptionOption = document.querySelector('.Avada-Subscription__Radio-Item:nth-child(2)');

    const oneTimePrice = oneTimeOption?.querySelector('.Avada-Subscription__Price');
    const subscriptionPrice = subscriptionOption?.querySelector('.Avada-Subscription__Price');

    if (!oneTimePrice || !subscriptionPrice) return;

    // Define correct prices for each variant
    const variantPrices = {
      "1 Bottle": { oneTime: "$99.00", sub: "$74.25" },
      "3 Bottles": { oneTime: "$299.99", sub: "$224.99" },
      "5 Bottles": { oneTime: "$499.99", sub: "$337.49" }
    };

    if (variantPrices[selectedVariant]) {
      oneTimePrice.textContent = variantPrices[selectedVariant].oneTime;
      subscriptionPrice.textContent = variantPrices[selectedVariant].sub;

      // Update the main price display
      const mainPriceElement = document.querySelector('.price-item--sale');
      if (mainPriceElement) {
        mainPriceElement.textContent = variantPrices[selectedVariant].oneTime;
      }
    }

    // Ensure the correct active class is applied
    const subscriptionRadio = subscriptionOption?.querySelector('input[type="radio"]');
    const oneTimeRadio = oneTimeOption?.querySelector('input[type="radio"]');

    if (subscriptionRadio?.checked) {
      oneTimeOption.classList.remove('Avada-Subscription__Radio-Item--Active');
      subscriptionOption.classList.add('Avada-Subscription__Radio-Item--Active');
    } else if (oneTimeRadio?.checked) {
      subscriptionOption.classList.remove('Avada-Subscription__Radio-Item--Active');
      oneTimeOption.classList.add('Avada-Subscription__Radio-Item--Active');
    }
  }

  // Attach event listeners to subscription selection
  document.querySelectorAll('.Avada-Subscription__Radio input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      updateSubscriptionPrices(document.querySelector('input[name="variant"]:checked')?.value);
    });
  });

  setupVariantSelection();

  // Observe changes in the variant selection area
  const observer = new MutationObserver(setupVariantSelection);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
// ///////////////////////////////////////////
